// extracted by mini-css-extract-plugin
export default {"side-drawer":"notifications-panel_side-drawer__T2doO","open":"notifications-panel_open__27ePq"};